import AddToCartButtonOld, {
  type PositionType,
  type Size
} from '@nespresso/catalog-components-react/controls/AddToCartButton';
import AddToCartButton from '@/widgets/components/controls/AddToCartButton/AddToCartButton.tsx';
import type { Product } from '@/domain/Product';

type AddToCartButtonDisplayerProps = {
  displayNewAddToBagButton: boolean;
  product: Product;
  namespace: string;
  class?: string;
  size?: Size;
  quantityPickerPosition?: PositionType;
};

export default function AddToCartButtonDisplayer({
  displayNewAddToBagButton,
  product,
  namespace,
  class: className,
  size,
  quantityPickerPosition
}: AddToCartButtonDisplayerProps) {
  // Note: Check "false" explicitly to avoid "undefined".
  // We use the new disabled component for better state control—it looks IDENTICAL to the old one,
  // but gives us full control and prevents external bugs.
  const isDisabled = product.inStock === false || product.isOrderable === false;

  if (displayNewAddToBagButton || isDisabled) {
    return (
      <AddToCartButton
        product={product}
        mode={size === 'small' ? 'icon-only' : 'icon-and-text'}
      />
    );
  }

  return (
    <AddToCartButtonOld
      namespace={namespace}
      className={className}
      productId={product.id}
      size={size}
      quantityPickerPosition={quantityPickerPosition}
    />
  );
}
